import { FacebookOutlined, InstagramOutlined, TikTokOutlined, YoutubeOutlined } from '@ant-design/icons';
import * as React from 'react';
import { facebookUrl, instagramUrl, tikTokUrl, youTubeUrl } from 'theme/libs/config';
import './SocialMedia.styles.less';
import { ISocialMediaProps } from "./SocialMedia.types";

export const SocialMedia = (props: ISocialMediaProps) =>
    <div className="SocialMedia">
        <ul className="social__list">
            {facebookUrl &&
                <li className="social__item social__item--facebook">
                    <a href={facebookUrl} target="_new"><FacebookOutlined /></a>
                </li>
            }
            {tikTokUrl &&
                <li className="social__item social__item--tiktok">
                    <a href={tikTokUrl} target="_new"><TikTokOutlined /></a>
                </li>
            }
            {instagramUrl &&
                <li className="social__item social__item--instagram">
                    <a href={instagramUrl} target="_new"><InstagramOutlined /></a>
                </li>
            }
            {youTubeUrl &&
                <li className="social__item social__item--youtube">
                    <a href={youTubeUrl} target="_new"><YoutubeOutlined /></a>
                </li>
            }
        </ul>
    </div>;
